(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('videosList', VideosListDirective)

    /** @ngInject */
    function VideosListDirective(PATHS) {
        function VideosListDirectiveController(HelperService) {
            const vm = this;

            let isPreviousInformative = false;

            vm.getVideoImage = video => {
                return HelperService.imageResizePath('videos', video.Id, video.Image, 500, 300);
            }

            vm.getVideoLink = video => {
                let videoUrl = '';

                if (isPreviousInformative)
                    videoUrl = `/university-lavpop/${video.VideoCategory.Url}/${video.Url}?NewsId=${vm.newsId}&NewsTitle=${vm.newsTitle}`;
                else
                    videoUrl = `/university-lavpop/${video.VideoCategory.Url}/${video.Url}`;

                return videoUrl;
            }

            vm.init = () => {
                if (vm.newsId && vm.newsTitle)
                    isPreviousInformative = true;
            }
        }

        function link(scope, attrs, elem, ctrl) {
            ctrl.init();
        }

        return {
            bindToController: true,
            controller: VideosListDirectiveController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/videos-list/videos-list.html`,
            link: link,
            scope: {
                videos: '=',
                newsId: '=',
                newsTitle: '='
            }
        }
    }
}());